<template>
  <v-dialog
    v-model="dialogShow"
    max-width="500px">
    <v-card>
      <v-card-title>{{ dialogTitle }}</v-card-title>
      <v-card-text>{{ dialogText }} </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-btn
          color="error"
          @click.stop="cancelBtnClick()">{{ cancelBtnTxt }}</v-btn>
        <v-spacer/>
        <v-btn
          color="success"
          @click.stop="saveBtnClick()">{{ saveBtnTxt }}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>

</template>

<script>
export default {
  name: 'DialogConfirmation',
  props: {
    dialogShow: {
      type: Boolean,
      default: false },
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogText: {
      type: String,
      default: ''
    },
    cancelBtnTxt: {
      type: String,
      default: ''
    },
    saveBtnTxt: {
      type: String,
      default: ''
    }
  },
  data: () => ({

  }),
  methods: {
    cancelBtnClick: function () {
      this.$emit('cancel-btn-dialog')
    },
    saveBtnClick: function () {
      this.$emit('save-btn-dialog')
    }
  }
}
</script>
